import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"

import styled from "styled-components"

import { GrNext } from "react-icons/gr"

const ParentCategoryButtonStyle = styled.div`
  /* border-bottom: 1px solid #eee; */
  flex-grow: 1;
  margin-bottom: 15px;
  box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.1);
  border-top: 3px solid #732619;

  background-color: white;
  font-size: 30px;
  cursor: pointer;
  padding: 15px;
  padding-right: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;


  @media only screen and (max-width: 500px) {
    font-size: 23px;
  }
`

const Icon = styled.div`
  svg {
    polyline {
      stroke: #555;
    }
  }
`

const ParentCategoryButton = ({ unicTitle, slug }) => {
  return (
    <Link to={`menu/${slug}`} style={{textDecoration: "none", color: "black"}}>
      <ParentCategoryButtonStyle>
          <span>{unicTitle}</span>
          <Icon><GrNext /></Icon>
      </ParentCategoryButtonStyle>
    </Link>
  )
}

ParentCategoryButton.propTypes = {
  unicTitle: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
}

export default ParentCategoryButton
